export default __webpack_public_path__ + "static/media/tools.4d2f19b0.svg";